import { mapInvestorUpdateArticleTeasers } from '@utils/blog';
import { RealEstateMarketingLandingPage } from 'types/sanity/real-estate-marketing';
import { RealEstateMarketingLandingPageQuery } from './queries/real-estate-marketing-page';
import { SanityGraphQLResponse } from 'types/sanity';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

type SanityRealEstateMarketingPageResponse = SanityGraphQLResponse<
	RealEstateMarketingLandingPage,
	'allRealEstateLandingPage'
>;

export async function getRealEstateMarketingPage(): Promise<RealEstateMarketingLandingPage | null> {
	const { data } = await useQuery<SanityRealEstateMarketingPageResponse>({
		client: villusClient,
		query: RealEstateMarketingLandingPageQuery,
		tags: ['real_estate_marketing_page']
	}).execute();

	if (data?.allRealEstateLandingPage[0]?.relatedArticlesSection?.relatedArticles?.length) {
		data.allRealEstateLandingPage[0].relatedArticlesSection.relatedArticles = mapInvestorUpdateArticleTeasers(
			data.allRealEstateLandingPage[0].relatedArticlesSection.relatedArticles
		);
	}

	return data?.allRealEstateLandingPage[0] ?? null;
}
